import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { priceToFormat } from "../../helpers/invoice";

import { BalanceAdjustment, RowInvoice } from "../../types/invoice";
import { InvoiceRows } from "../index";

import styles from "./BalanceAdjustmentsDetails.module.scss";

interface Props {
  balanceAdjustments: BalanceAdjustment[];
}

const BalanceAdjustmentsDetails = ({ balanceAdjustments }: Props) => {
  const { t } = useTranslation();

  const balanceAdjustmentRows: RowInvoice[] = useMemo((): RowInvoice[] => {
    return [
      {
        name: t("invoices.balanceAdjustments"),
        key: "balanceAdjustmentsTitle",
        value: "",
        isTitle: true,
      },
      ...balanceAdjustments.map((balanceRow: BalanceAdjustment) => ({
        name: balanceRow.name,
        key: balanceRow.paymentBalanceAdjustmentId.toString(),
        value: priceToFormat(balanceRow.amount),
      })),
    ];
  }, [t, balanceAdjustments]);

  return (
    <table className={styles.balanceAdjustmentDetailsBody}>
      <tbody>
        {balanceAdjustmentRows.map((row) => {
          return <InvoiceRows key={row.key} {...row} />;
        })}
      </tbody>
    </table>
  );
};

export default BalanceAdjustmentsDetails;
